<template>
  <v-data-table
    :headers="headers"
    :options="{ itemsPerPage: 15 }"
    :items="items"
    sort-by="key"
    :search="search"
    class="elevation-0 general-table"
    :loading="isLoading"
    :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
  >
    <template v-slot:top>
      <div class="d-flex align-center flex-wrap py-2 mb-3">
        <v-text-field
          clearable
          class="general-table__search"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="$t('GLOBAL-DO_SEARCH')"
          solo
          flat
          dense
          hide-details
        >
        </v-text-field>

        <v-spacer></v-spacer>
      </div>
    </template>

    <template v-slot:footer.page-text="props" v-if="items.length > 0">
      <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
      <display-number :number="items.length" />
    </template>

    <template v-slot:header.key="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-KEY"></lang>
    </template>

    <template v-slot:header.lang.en.value="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-LANG-EN"></lang>
    </template>

    <template v-slot:header.lang.de.value="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-LANG-DE"></lang>
    </template>

    <template v-slot:header.lang.es.value="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-LANG-ES"></lang>
    </template>

    <template v-slot:header.lang.nl.value="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-LANG-NL"></lang>
    </template>

    <template v-slot:header.lang.fr.value="{ header }">
      <lang t="TRANSLATIONS-TBL-HEADER-LANG-FR"></lang>
    </template>

    <template v-slot:item.lang.de.value="props">
      <v-edit-dialog :return-value.sync="props.item.lang.de.value" @save="save('de', props.item)">
        <div>{{ props.item.lang.de.value }}</div>

        <template v-slot:input>
          <v-text-field v-model="props.item.lang.de.value" single-line> </v-text-field>
        </template>
      </v-edit-dialog>
    </template>

    <template v-slot:item.lang.en.value="props">
      <v-edit-dialog :return-value.sync="props.item.lang.en.value" @save="save('en', props.item)">
        <div>{{ props.item.lang.en.value }}</div>

        <template v-slot:input>
          <v-text-field v-model="props.item.lang.en.value" single-line> </v-text-field>
        </template>
      </v-edit-dialog>
    </template>

    <template v-slot:item.lang.es.value="props">
      <v-edit-dialog :return-value.sync="props.item.lang.es.value" @save="save('es', props.item)">
        <div>{{ props.item.lang.es.value }}</div>

        <template v-slot:input>
          <v-text-field v-model="props.item.lang.es.value" single-line> </v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.lang.nl.value="props">
      <v-edit-dialog :return-value.sync="props.item.lang.nl.value" @save="save('nl', props.item)">
        <div>{{ props.item.lang.nl.value }}</div>

        <template v-slot:input>
          <v-text-field v-model="props.item.lang.nl.value" single-line> </v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.lang.fr.value="props">
      <v-edit-dialog :return-value.sync="props.item.lang.fr.value" @save="save('fr', props.item)">
        <div>{{ props.item.lang.fr.value }}</div>

        <template v-slot:input>
          <v-text-field v-model="props.item.lang.fr.value" single-line> </v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import DisplayNumber from "../../../components/DisplayNumber.vue";

export default {
  name: "TranslationIndex",
  components: {
    DisplayNumber,
  },
  data: () => ({
    isSaving: false,
    isLoading: true,

    search: "",

    headers: [
      { text: "Key", value: "key", align: "start", sortable: true, class: "general-table__th--6" },
      { text: "en", value: "lang.en.value", sortable: false, class: "general-table__th--6" },
      { text: "de", value: "lang.de.value", sortable: false, class: "general-table__th--6" },
      { text: "es", value: "lang.es.value", sortable: false, class: "general-table__th--6" },
      { text: "nl", value: "lang.nl.value", sortable: false, class: "general-table__th--6" },
      { text: "fr", value: "lang.fr.value", sortable: false, class: "general-table__th--6" },
    ],

    languages: [],
    items: [],
  }),

  created() {
    this.initialize();
  },
  computed:{
    currentUserUnitSystem() {
      return this.$store.getters.currentUser.unitSystem;
    }
  },
  mounted() {},

  methods: {
    initialize() {
      this.isLoading = true;

      this.axios.get("languages").then((response) => {
        this.languages = response.data;

        this.axios.get("labels?language=all"+"&unitSystem="+this.currentUserUnitSystem).then((res) => {

          for (let key in res.data) {
            this.items.push({
              key: key,
              lang: {
                en: res.data[key].en ? res.data[key].en : { value: "" },
                de: res.data[key].de ? res.data[key].de : { value: "" },
                es: res.data[key].es ? res.data[key].es : { value: "" },
                nl: res.data[key].nl ? res.data[key].nl : { value: "" },
                fr: res.data[key].fr ? res.data[key].fr : { value: "" },
              },
            });
          }

          this.isLoading = false;
        });
      });
    },

    save(lang, item) {
      let langId = this.languages.filter((_) => _.shortcode == lang)[0].id;

      let saveObj = {
        language_id: langId,
        key: item.key,
        value: item.lang[lang].value,
      };

      // update existing one
      if (item.lang[lang].id) {
        this.axios.put("labels/" + item.lang[lang].id, saveObj);

        // create new one
      } else {
        this.axios.post("labels", saveObj);
      }
    },

    close() {
    },

    deleteItem(item) {
      return;
    },
  },
};
</script>

<style lang="scss"></style>
